import { AbstractControl, FormControl } from '@angular/forms';

export class PasswordValidation {

  static Password(password: string) {
    const base_10 = (/[0-9]{1}/).test(password);
    const uppercase = (/[A-Z]{1}/).test(password);
    const lowercase = (/[a-z]{1}/).test(password);
    const non_alphabetic = (/(?=[^a-zA-Z])(?=[^0-9]){1}/).test(password);

    const inputValid = base_10 && uppercase && lowercase && non_alphabetic;

    if (!inputValid) return { base_10, uppercase, lowercase, non_alphabetic };
    else return true;
  }

  static MatchPassword(AC: AbstractControl) {
    const confirmPasswordControl = AC.get('repeatPassword') || AC.get('rep_password');

    // Get values
    const password = (AC.get('password')) ? AC.get('password').value : AC.get('new_password').value; // to get value in input tag
    const confirmPassword = confirmPasswordControl.value; // to get value in input tag

    if (!confirmPassword) {
      confirmPasswordControl.setErrors({ key: 'Required' });
    }
    else if (password !== confirmPassword) {
      confirmPasswordControl.setErrors({ key: 'NotMatch' });
    }
    else {
      confirmPasswordControl.setErrors(null);
      return null;
    }
  }

  static PassRequirements(username: string) {
    return (AC: AbstractControl) => {
      let password: string = AC.get('new_password').value;

      if (password) {
        // To lower case
        if (password) password = password.toLowerCase();
        if (username) username = username.toLowerCase();

        // Check empty
        if (password.length === 0)
          AC.get('new_password').setErrors({ key: 'Required' });
        // Check minimum of length
        else if (password.length < 6)
          AC.get('new_password').setErrors({ key: 'MatchLength' });
        // Check if the password match with the username
        else if ((password && username) && password.includes(username))
          AC.get('new_password').setErrors({ key: 'MatchUsername' });
        // Default
        else {
          AC.get('new_password').setErrors(null);
          return true;
        }
      }
      else return true;
    };
  }

  static PasswordRequirements(AC: AbstractControl) {
    let password: string = AC.get('password').value;
    let username: string = AC.get('email').value;

    // To lower case
    if (password) password = password.toLowerCase();
    if (username) username = username.toLowerCase();

    // Check empty
    if (password && password.length === 0)
      AC.get('password').setErrors({ key: 'Required' });
    // Check minimum of length
    else if (password && password.length < 6)
      AC.get('password').setErrors({ key: 'MatchLength' });
    // Check if the password match with the username
    else if ((password && username) && password.includes(username))
      AC.get('password').setErrors({ key: 'MatchUsername' });
    // Default
    else {
      AC.get('password').setErrors(null);
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/validators/password/password.validator.ts